<script setup>
import { ref, watch, onMounted } from "vue"
import { XCircleIcon } from "@heroicons/vue/16/solid"
import { DateTime } from "luxon"
import DatePopup from "./DatePopup.vue"
import { useFilteredFeedStore } from "../utils/store.js"

const store = useFilteredFeedStore()

const toggled = ref(false)

const selected = ref(null)

function setDate(start, end, when) {

	if( selected.value !== when ){
		selected.value = when
	}else{
		selected.value = null
		delete store.filters.start_date
		delete store.filters.end_date
		store.setState()
		return
	}

	if( store.filters.start_date !== start ){
		store.updateFilters({
			taxonomy: "start_date",
			term: start,
		})
	}

	store.updateFilters({
		taxonomy: "end_date",
		term: end,
	})

	store.fetchItems()

}

function selectToday() {
	const today = DateTime.now().toFormat('yyyy-MM-dd')
	setDate(today,today,'today')
}

function selectWeek() {
	const today = DateTime.now().toFormat('yyyy-MM-dd')
	const lastdayofweek = DateTime.now().plus({days: 7}).toFormat('yyyy-MM-dd')

	setDate(today,lastdayofweek,'week')

}

function selectMonth() {
	const today = DateTime.now().toFormat('yyyy-MM-dd')
	const lastdayofweek = DateTime.now().endOf('month').toFormat('yyyy-MM-dd')

	setDate(today,lastdayofweek,'month')

}

onMounted(() => {

	watch(store.filters,() => {
	
		if( Object.keys(store.filters).length === 0 && store.filters.constructor === Object ) {
			selected.value = null
		}

	},{ deep: true })
})


</script>
<template>
	<div class="py-6 flex flex-col md:flex-row gap-8">
		<button class="md:pointer-events-none flex justify-between gap-4 items-center" @click="toggled = !toggled">
			<span>When?</span>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 md:hidden" :class="{ 'rotate-180': toggled }" >
				<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
			</svg>
		</button>
		<div class="grow-1 hidden md:flex flex-wrap gap-2 -mx-3 md:mx-0" :class="{ '!flex': toggled }" >
			<a href="#" @click.prevent="selectToday()" class="font-bold transition py-2 px-3 inline-flex gap-3 items-center rounded-full" :class="{ 'ring-0 bg-orange text-purple hover:bg-white' : selected === 'today' }">
				<span>Today</span>
				<XCircleIcon v-if="selected === 'today'" class="size-6" />
			</a>
			<a href="#" @click.prevent="selectWeek()" class="font-bold transition py-2 px-3 inline-flex gap-3 items-center rounded-full" :class="{ 'ring-0 bg-orange text-purple hover:bg-white' : selected === 'week' }">
				<span>This week</span>
				<XCircleIcon v-if="selected === 'week'" class="size-6" />
			</a>
			<a href="#" @click.prevent="selectMonth()" class="font-bold transition py-2 px-3 inline-flex gap-3 items-center rounded-full" :class="{ 'ring-0 bg-orange text-purple hover:bg-white' : selected === 'month' }">
				<span>This month</span>
				<XCircleIcon v-if="selected === 'month'" class="size-6" />
			</a>
			<DatePopup class="py-2 px-3">Search with calendar</DatePopup>
		</div>
	</div>
</template>